var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      class: _vm.$conf.sidebar.enabled ? "" : "on-edge",
      attrs: { id: "dataselector" },
    },
    [
      _vm.tileSetCount > 0
        ? _c(
            "b-dropdown",
            {
              attrs: { id: "tileset-selector", "aria-role": "list" },
              model: {
                value: _vm.checkedTileSet,
                callback: function ($$v) {
                  _vm.checkedTileSet = $$v
                },
                expression: "checkedTileSet",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-dark has-background-black-bis",
                  attrs: { slot: "trigger", type: "button" },
                  slot: "trigger",
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.checkedTileSet))]),
                  _vm._v(" "),
                  _c("b-icon", { attrs: { icon: "menu-down" } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.tileSets, function (item) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: item,
                    attrs: { value: item, "aria-role": "listitem" },
                    on: { click: _vm.tileSetChanged },
                  },
                  [_vm._v("\n      " + _vm._s(item) + "\n    ")]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.propertyCount > 1
        ? _c(
            "b-dropdown",
            {
              attrs: { id: "property-selector", "aria-role": "list" },
              model: {
                value: _vm.checkedProperty,
                callback: function ($$v) {
                  _vm.checkedProperty = $$v
                },
                expression: "checkedProperty",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "button is-dark has-background-black-bis",
                  attrs: { slot: "trigger", type: "button" },
                  slot: "trigger",
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.checkedProperty))]),
                  _vm._v(" "),
                  _c("b-icon", { attrs: { icon: "menu-down" } }),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.properties, function (item) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: item,
                    attrs: { value: item, "aria-role": "listitem" },
                    on: { click: _vm.propertyChanged },
                  },
                  [_vm._v("\n      " + _vm._s(item) + "\n    ")]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }